import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Slide from '@mui/material/Slide';
import { useMutation } from 'react-query';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultEditForm = {
  amount: '',
  source: '',
  address: '',
  coin_name: '',
  status: '',
};

export default function WithdrawalList() {
  const formatPrice = (amount, currency) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

  const [withdrawals, setwithdrawals] = useState(null);
  const { isLoading: isLoadingwithdrawals, refetch: getwithdrawals } = useQuery(
    'list-withdrawals',
    async () => {
      return await apiClient.get('/api/list-withdrawals');
    },
    {
      enabled: false,
      onSuccess: (res) => {
        if (res.data.status === 'success') {
          setwithdrawals(res.data.withdrawals);
          const event2 = new Event('processed');
          window.dispatchEvent(event2);
        }
      },
      onError: (err) => {
        // console.log(err.response?.data || err);
      },
    }
  );

  useEffect(() => {
    getwithdrawals();
    if (isLoadingwithdrawals) {
      const event3 = new Event('processing');
      window.dispatchEvent(event3);
    }
  }, []);

  const notify = (message, type = 'success') => {
    localStorage.setItem('notification', JSON.stringify({ message, type }));
    window.dispatchEvent(new Event('newMessage'));
  };

  const refetchList = () => {
    getwithdrawals();
    window.dispatchEvent(new Event('processed'));
  };

  // Edit dialog state
  const [editOpen, setEditOpen] = useState(false);
  const [editForm, setEditForm] = useState(defaultEditForm);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [loadingOne, setLoadingOne] = useState(false);

  const openEdit = (withdrawal) => {
    setSelectedWithdrawal(withdrawal);
    setEditForm({
      amount: String(withdrawal.amount ?? ''),
      source: withdrawal.source ?? '',
      address: withdrawal.address ?? '',
      coin_name: withdrawal.coin_name ?? '',
      status: withdrawal.status ?? '',
    });
    setEditOpen(true);
  };

  const closeEdit = () => {
    setEditOpen(false);
    setSelectedWithdrawal(null);
    setEditForm(defaultEditForm);
  };

  // Full update (PUT /api/withdrawals/:id)
  const { isLoading: isUpdating, mutate: updateWithdrawal } = useMutation(
    async () => {
      const id = selectedWithdrawal?.id;
      if (!id) return;
      return await apiClient.put(`/api/withdrawals/${id}`, {
        amount: editForm.amount ? Number(editForm.amount) : undefined,
        source: editForm.source || undefined,
        address: editForm.address || undefined,
        coin_name: editForm.coin_name || undefined,
        status: editForm.status || undefined,
      });
    },
    {
      onSuccess: (res) => {
        if (res?.data?.status === 'success') {
          notify(res.data.message || 'Withdrawal updated successfully');
          closeEdit();
          refetchList();
        } else {
          notify(res?.data?.message || 'Update failed', 'error');
        }
      },
      onError: (err) => {
        const msg = err.response?.data?.message || err.message || 'Failed to update withdrawal';
        notify(msg, 'error');
      },
    }
  );

  // Delete
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  const openDelete = (withdrawal) => {
    setToDelete(withdrawal);
    setDeleteOpen(true);
  };

  const closeDelete = () => {
    setDeleteOpen(false);
    setToDelete(null);
  };

  const { isLoading: isDeleting, mutate: deleteWithdrawal } = useMutation(
    async () => {
      if (!toDelete?.id) return;
      return await apiClient.delete(`/api/withdrawals/${toDelete.id}`);
    },
    {
      onSuccess: (res) => {
        if (res?.data?.status === 'success') {
          notify(res.data.message || 'Withdrawal deleted successfully');
          closeDelete();
          refetchList();
        } else {
          notify(res?.data?.message || 'Delete failed', 'error');
        }
      },
      onError: (err) => {
        const msg = err.response?.data?.message || err.message || 'Failed to delete withdrawal';
        notify(msg, 'error');
      },
    }
  );

  // Status-only update (POST /api/update-withdrawal) – sends email to user
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusWithdrawalId, setStatusWithdrawalId] = useState('');
  const [statusWithdrawalStatus, setStatusWithdrawalStatus] = useState('');

  const openStatusDialog = (withdrawal) => {
    setStatusWithdrawalId(withdrawal.id);
    setStatusWithdrawalStatus(withdrawal.status || '');
    setStatusDialogOpen(true);
  };

  const closeStatusDialog = () => {
    setStatusDialogOpen(false);
    setStatusWithdrawalId('');
    setStatusWithdrawalStatus('');
  };

  const { isLoading: isUpdatingStatus, mutate: updateWithdrawalStatus } = useMutation(
    async () => {
      return await apiClient.post('/api/update-withdrawal', {
        withdrawal_id: statusWithdrawalId,
        withdrawal_status: statusWithdrawalStatus,
      });
    },
    {
      onSuccess: (res) => {
        if (res?.data?.status === 'success') {
          notify(res.data.message || 'Status updated – email sent to user');
          closeStatusDialog();
          refetchList();
        } else {
          notify(res?.data?.message || 'Update failed', 'error');
        }
      },
      onError: (err) => {
        const msg = err.response?.data?.message || err.message || 'Failed to update status';
        notify(msg, 'error');
      },
    }
  );

  const getDate = (date) => new Date(date).toDateString();

  return (
    <div style={{ marginTop: '75px' }}>
      <Container>
        <Typography
          mt={4}
          mb={2}
          sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }}
          gutterBottom
          variant="h6"
          component="div"
        >
          {isLoadingwithdrawals ? 'Loading...' : 'List of Withdrawals'}
        </Typography>
        <TableContainer component={Paper}>
          {withdrawals !== null && (
            <Table sx={{ minWidth: '100%' }} size="small" aria-label="withdrawals table">
              <TableHead>
                <TableRow>
                  <TableCell>User Name</TableCell>
                  <TableCell align="right">User Email</TableCell>
                  <TableCell align="right">Amount</TableCell>
                  <TableCell align="right">Coin</TableCell>
                  <TableCell align="right">Address</TableCell>
                  <TableCell align="right">Status</TableCell>
                  <TableCell align="right">Withdrawal Source</TableCell>
                  <TableCell align="right">Date</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {withdrawals.map((withdrawal) => (
                  <TableRow
                    key={withdrawal.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {withdrawal.user?.name}
                    </TableCell>
                    <TableCell align="right">{withdrawal.user?.email}</TableCell>
                    <TableCell align="right">{formatPrice(withdrawal.amount, withdrawal.user?.currency)}</TableCell>
                    <TableCell align="right">{withdrawal.coin_name}</TableCell>
                    <TableCell align="right">{withdrawal.address}</TableCell>
                    <TableCell align="right">{withdrawal.status}</TableCell>
                    <TableCell align="right">{withdrawal.source}</TableCell>
                    <TableCell align="right">{getDate(withdrawal.created_at)}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        onClick={() => openStatusDialog(withdrawal)}
                        variant="outlined"
                        color="secondary"
                        sx={{ mr: 0.5 }}
                      >
                        Update status
                      </Button>
                      <Button
                        size="small"
                        onClick={() => openEdit(withdrawal)}
                        startIcon={<EditIcon />}
                        variant="outlined"
                        color="primary"
                        sx={{ mr: 0.5 }}
                      >
                        Edit
                      </Button>
                      <IconButton
                        size="small"
                        onClick={() => openDelete(withdrawal)}
                        color="error"
                        title="Delete withdrawal"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Container>

      {/* Edit dialog – full withdrawal details */}
      <Dialog
        open={editOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeEdit}
        maxWidth="sm"
        fullWidth
        aria-describedby="edit-withdrawal-dialog"
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          Edit Withdrawal {selectedWithdrawal ? `#${selectedWithdrawal.id}` : ''}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <TextField
              label="Amount"
              type="number"
              value={editForm.amount}
              onChange={(e) => setEditForm((f) => ({ ...f, amount: e.target.value }))}
              inputProps={{ step: 0.01, min: 0 }}
              fullWidth
            />
            <TextField
              label="Source"
              value={editForm.source}
              onChange={(e) => setEditForm((f) => ({ ...f, source: e.target.value }))}
              fullWidth
            />
            <TextField
              label="Address"
              value={editForm.address}
              onChange={(e) => setEditForm((f) => ({ ...f, address: e.target.value }))}
              fullWidth
              multiline
            />
            <TextField
              label="Coin name"
              value={editForm.coin_name}
              onChange={(e) => setEditForm((f) => ({ ...f, coin_name: e.target.value }))}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel id="edit-status-label">Status</InputLabel>
              <Select
                labelId="edit-status-label"
                value={editForm.status}
                label="Status"
                onChange={(e) => setEditForm((f) => ({ ...f, status: e.target.value }))}
              >
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="declined">Declined</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeEdit}>Cancel</Button>
          <Button
            onClick={() => updateWithdrawal()}
            variant="contained"
            color="primary"
            disabled={isUpdating}
            startIcon={isUpdating ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {isUpdating ? 'Saving...' : 'Save changes'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update status only – sends email to user (POST /api/update-withdrawal) */}
      <Dialog
        open={statusDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeStatusDialog}
        aria-describedby="update-status-dialog"
      >
        <DialogTitle sx={{ textAlign: 'center' }}>Update status</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Change the status and notify the user by email.
          </Typography>
          <FormControl fullWidth sx={{ minWidth: 200 }}>
            <InputLabel id="status-only-label">Status</InputLabel>
            <Select
              labelId="status-only-label"
              value={statusWithdrawalStatus}
              label="Status"
              onChange={(e) => setStatusWithdrawalStatus(e.target.value)}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="approved">Approved</MenuItem>
              <MenuItem value="declined">Declined</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeStatusDialog}>Cancel</Button>
          <Button
            onClick={() => updateWithdrawalStatus()}
            variant="contained"
            color="secondary"
            disabled={isUpdatingStatus}
            startIcon={isUpdatingStatus ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {isUpdatingStatus ? 'Updating...' : 'Update status'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete confirmation dialog */}
      <Dialog
        open={deleteOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeDelete}
        aria-describedby="delete-withdrawal-dialog"
      >
        <DialogTitle>Delete withdrawal?</DialogTitle>
        <DialogContent>
          {toDelete && (
            <Typography>
              This will permanently delete withdrawal #{toDelete.id} (Amount:{' '}
              {formatPrice(toDelete.amount)}, User: {toDelete.user?.name}). This action cannot be undone.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeDelete}>Cancel</Button>
          <Button
            onClick={() => deleteWithdrawal()}
            variant="contained"
            color="error"
            disabled={isDeleting}
            startIcon={isDeleting ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}